<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
        <div class="col-md-12" style="margin-top: 15px">
          <button class="btn btn-info" type="button" v-on:click="addRoute"><i class="fa fa-fw fa-plus"></i> {{ _('Add route') }}</button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h3>{{ _('Menu') }}</h3>
        </div>
      </div>
      <ul class="list-group">
        <draggable group="routes" v-model="activeRoutes" draggable=".list-group-item" :delay="100" :delayOnTouchOnly="true" v-on:sort="throttledSort">
          <li class="list-group-item" v-for="route in activeRoutes">
            <div class="row">
              <div class="col-md-4" v-on:click="selectRoute(route)">
                {{ route.path }}
              </div>
              <div class="col-md-4">
                <i :class="'fa fa-fw fa-' + routeTypeIcon(route)"></i> {{ routeName(route) }}
              </div>
            </div>
            <transition name="fade">
              <div class="row" v-if="selectedRoute && selectedRoute.id === route.id">
                <div class="col-md-4">
                  <route-details v-model="selectedRoute" :categories="categories" :products="products" :templates="templates" v-on:input="saveRoute" v-on:delete="deleteRoute" v-on:close="closeDetails" />
                </div>
              </div>
            </transition>
          </li>
        </draggable>
      </ul>
      <div class="row">
        <div class="col-md-12">
          <h3>{{ _('Other routes') }}</h3>
        </div>
      </div>
      <ul class="list-group">
        <draggable group="routes" v-model="otherRoutes" draggable=".list-group-item" :delay="100" :delayOnTouchOnly="true" v-on:sort="throttledSort">
          <li class="list-group-item" v-for="route in otherRoutes">
            <div class="row">
              <div class="col-md-4" v-on:click="selectRoute(route)">
                {{ route.path }}
              </div>
              <div class="col-md-4">
                <i :class="'fa fa-fw fa-' + routeTypeIcon(route)"></i> {{ routeName(route) }}
              </div>
            </div>
            <transition name="fade">
              <div class="row" v-if="selectedRoute && selectedRoute.id === route.id">
                <div class="col-md-4">
                  <route-details v-model="selectedRoute" :categories="categories" :products="products" :templates="templates" v-on:input="saveRoute" v-on:delete="deleteRoute" v-on:close="closeDetails" />
                </div>
              </div>
            </transition>
          </li>
        </draggable>
      </ul>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import { RouteDetails, ModalRouteDetails } from '#components'
import throttle from 'lodash/throttle'

export default {
  data () {
    return {
      routes: [],
      templates: [],
      products: [],
      categories: [],
      selectedRoute: null,
      sortedActiveRoutes: null,
      sortedOtherRoutes: null
    }
  },
  mixins: [components],
  computed: {
    data () {
      return JSON.parse(this.component.data)
    },
    activeRoutes: {
      get () {
        if (this.sortedActiveRoutes) {
          return this.sortedActiveRoutes
        }
        return this.routes.filter((r) => !!r.menu)
      },
      set (newValue) {
        this.sortedActiveRoutes = newValue
      }
    },
    otherRoutes: {
      get () {
        if (this.sortedOtherRoutes) {
          return this.sortedOtherRoutes
        }
        return this.routes.filter((r) => !r.menu)
      },
      set (newValue) {
        this.sortedOtherRoutes = newValue
      }
    }
  },
  methods: {
    selectPos (pos) {
      this.selectedPos = pos
    },
    selectRoute (route) {
      this.selectedRoute = route
    },
    throttledSort: throttle(function () { this.sort() }, 100, { leading: false, trailing: true }),
    async sort () {
      let response
      let sortData = {
        sort: this.activeRoutes.map((r) => r.id),
        reset: this.otherRoutes.map((r) => r.id)
      }
      try {
        await axios.put(this.baseDomain + this.shopId + '/cmsroutes.json?apikey=' + this.apiKey, sortData)
      } catch(e) {}
    },
    routeTypeIcon (route) {
      const type = this.routeType(route)
      switch(type) {
        case 'product':
          return 'cubes'
        case 'category':
          return 'folder-open'
        case 'link':
        default:
          return type
      }
    },
    routeType (route) {
      if (route.type === 'link') {
        return 'link'
      }
      if (route.product) {
        return 'product'
      }
      if (route.category) {
        return 'category'
      }
      return ''
    },
    routeName (route) {
      if (route.redirect) {
        return route.redirect
      }
      if (!route.product && !route.category) {
        return ''
      }
      let use
      if (route.product) {
        use = route.product
      } else if (route.category) {
        use = route.category
      }
      let locale = route.defaultLocale
      if (use.locale && use.locale[locale]) {
        return use.locale[locale].title
      }
      return ''
    },
    async loadRoutes () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/cmsroutes.json?apikey=' + this.apiKey)
      } catch(e) {
        this.routes = []
        return
      }
      this.routes = response.data
      this.sortedActiveRoutes = null
      this.sortedOtherRoutes = null
    },
    async loadTemplates () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/cmstemplates.json?apikey=' + this.apiKey)
      } catch(e) {
        this.templates = []
        return
      }
      this.templates = response.data
    },
    async loadProducts () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/cmsproducts.json?apikey=' + this.apiKey)
      } catch(e) {
        this.products = []
        return
      }
      this.products = response.data
    },
    async loadCategories () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/cmscategories.json?apikey=' + this.apiKey)
      } catch(e) {
        this.categories = []
        return
      }
      this.categories = response.data
    },
    async saveRoute (route) {
      this.closeDetails()
      // Optimistically set the new route data
      if (route.id) {
        for (let i = 0; i < this.routes.length; i++) {
          if (this.routes[i].id === route.id) {
            this.routes[i] = route
            break
          }
        }
        // Save route details to db
        try {
          await axios.put(this.baseDomain + this.shopId + '/cmsroutes/' + route.id + '.json?apikey=' + this.apiKey, route)
        } catch(e) {
          console.log(e)
        }
      } else {
        // Save route details to db
        try {
          if(!route.root)  {
            route.root = 1 // Defaults to default root
          }
          let order = 1
          for (var i = 0; i < this.routes.length; i++) {
            if (this.routes[i].order) {
              order = Math.max(order, this.routes[i].order)
            }
          }
          route.order = order + 1 // Append it a the end
          this.routes.push(route) // Optimistic add
          await axios.post(this.baseDomain + this.shopId + '/cmsroutes.json?apikey=' + this.apiKey, route)
        } catch(e) {
          console.log(e)
        }
      }
    },
    closeDetails () {
      this.selectedRoute = null
    },
    addRoute () {
      this.showModal('routedetails', ModalRouteDetails, {
        props: {
          selectedRoute: {
            defaultLocale: this.locale,
            type: 'direct',
            menu: true
          },
          categories: this.categories,
          products: this.products,
          templates: this.templates
        },
        events: {
          save: this.saveRoute
        },
        handlers: {},
        width: 1000
      })
    },
    async deleteRoute (route) {
      if (route && route.id) {
        try {
          await axios.delete(this.baseDomain + this.shopId + '/cmsroutes/' + route.id + '.json?apikey=' + this.apiKey)
        } catch(e) {
          console.log(e)
        }
      }
      this.selectedRoute = null
    },
    throttledReloadRoutes: throttle(function () { this.loadRoutes() }, 500, { leading: false, trailing: true }),
    throttledReloadTemplates: throttle(function () { this.loadTemplates() }, 500, { leading: false, trailing: true }),
    throttledReloadProducts: throttle(function () { this.loadProducts() }, 500, { leading: false, trailing: true }),
    throttledReloadCategories: throttle(function () { this.loadCategories() }, 500, { leading: false, trailing: true }),
  },
  mounted () {
    this.loadRoutes()
    this.loadTemplates()
    this.loadProducts()
    this.loadCategories()
    if(!this.events) {
      let events = {}
      events['cmsrouteUpdate'] = (message) => {
        if (this.shopId == message.shopId) {
          return this.throttledReloadRoutes()
        }
      }
      events['cmstemplateUpdate'] = (message) => {
        if (this.shopId == message.shopId) {
          return this.throttledReloadTemplates()
        }
      }
      events['cmsproductUpdate'] = (message) => {
        if (this.shopId == message.shopId) {
          return this.throttledReloadProducts()
        }
      }
      events['cmscategoryUpdate'] = (message) => {
        if (this.shopId == message.shopId) {
          return this.throttledReloadCategories()
        }
      }
      this.events = events
    }
    this.enableEventBus()
  },
  components: {
    RouteDetails,
  }
}
</script>